import React from 'react';
import { ITask } from './taskQueries';
import { groupBy } from 'ramda';
import { IGroup } from './Tasks';
import ActivityRoutineModel from '../../Model/ProcessModel/ActivityRoutineModel';
import { rutiner } from '../../Features/Delsystem/_Common/Const/Rutiner';
import { rutinInfos } from '../../Features/Delsystem/_Common/Const/RutinInfo';
import { ProcessAktivitetIDType } from '../../Types/ProcessModel';
import { Link } from 'react-router';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDAvatar from '../../BaseComponents/Avatar/EDAvatar';

export const getTotalNumberOfTasks = (tasks: ITask[]) =>
  tasks.reduce((prev, curr) => {
    const antal = curr.ANTAL != null ? curr.ANTAL : 0;
    return prev + antal;
  }, 0);

export const groupByTasks = (tasks: ITask[]): IGroup[] => {
  let groups = groupBy((task: ITask) => task.PAKT_ID.toString())(tasks);

  return Object.keys(groups).map((groupKey: string) => {
    let taskGroup = groups[groupKey];

    let groupedByDatabase = groupBy((task: ITask) => task.DBNAME)(taskGroup);

    let subgroup = Object.keys(groupedByDatabase).map(databaseKey => {
      return {
        name: databaseKey,
        tasks: groupedByDatabase[databaseKey],
      };
    });

    const numberOfTasks = getTotalNumberOfTasks(taskGroup);

    return {
      name: taskGroup[0].ProcAktivitet,
      numberOfTasks,
      subgroup: subgroup,
    };
  });
};

export const groupByDatabase = (tasks: ITask[]): IGroup[] => {
  let groups = groupBy((task: ITask) => task.DBNAME.toString())(tasks);

  return Object.keys(groups).map((groupKey: string) => {
    let taskGroup = groups[groupKey];

    let groupedByTask = groupBy((task: ITask) => task.PAKT_ID.toString())(
      taskGroup
    );

    let subgroup = Object.keys(groupedByTask).map((key, index) => {
      return {
        name: taskGroup[index].ProcAktivitet,
        tasks: [taskGroup[index]], // TODO: Will not work when more than of same task on same db
      };
    });

    const numberOfTasks = getTotalNumberOfTasks(taskGroup);

    return {
      name: taskGroup[0].DBNAME,
      numberOfTasks,
      subgroup: subgroup,
    };
  });
};

export const getTaskText = (
  text: string,
  ProcAktivitetId: ProcessAktivitetIDType,
  dbname: string,
  index: number
) => {
  const routineID = ActivityRoutineModel[ProcAktivitetId];
  const routinePath = Object.keys(rutiner).find(
    key =>
      rutinInfos[key as keyof typeof rutinInfos] &&
      rutinInfos[key as keyof typeof rutinInfos].rutinID === routineID
  );

  if (routinePath) {
    return (
      <Link to={`/${dbname}/rutin/${routinePath}`} key={index}>
        <EDTypography>{text}</EDTypography>
      </Link>
    );
  }

  return <div key={index}>{text}</div>;
};

export const getLabel = (
  label: string,
  numberOfItems: number,
  beRed: boolean
) => (
  <React.Fragment>
    <EDAvatar
      sx={{
        width: 24,
        height: 24,
        marginRight: 2,
        fontSize: 16,
        bgcolor: beRed
          ? 'customProperties.Warning.main'
          : 'customProperties.Tasks.main',
        color: beRed
          ? 'customProperties.Warning.contrastText'
          : 'customProperties.Tasks.contrastText',
        '&:hover': {
          bgcolor: beRed
            ? 'customProperties.Warning.dark'
            : 'customProperties.Tasks.dark',
        },
      }}
    >
      {numberOfItems}
    </EDAvatar>
    <EDTypography variant="subtitle1">{label}</EDTypography>
  </React.Fragment>
);
